import { useBucket } from '@mc/experiments-react'

export const EXPERIMENT_KEY = 'pen-4604_v1'

export const useIsPen4604Enabled = () =>
  useBucket(EXPERIMENT_KEY) === 'variant_1'
